<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editData" ref="editDataRef" label-width="180px">
        <el-form-item label="">
          <label slot="label">
            <span style="color: #FF0000;">项目(必填)</span>
          </label>
          <el-select v-model="editData.Projectid" placeholder="请选择项目" class="select" style="width: 150px;">
            <el-option
              v-for="item in projectlist" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">日期(必填)</span>
          </label>
          <el-date-picker v-model="editData.Projecttime" type="date" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="品名(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectproductname" placeholder="请输入品名"></el-input>
        </el-form-item>
        <el-form-item label="预算单价(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectyujiprice" placeholder="请输入预算单价"></el-input>
        </el-form-item>
        <el-form-item label="数量(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectnum" placeholder="请输入数量"></el-input>
        </el-form-item>
        <el-form-item label="预计完成天数(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectyujidays" placeholder="请输入预计完成天数"></el-input>
        </el-form-item>
        <el-form-item label="实际完成时间(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectshijidays" placeholder="请输入实际完成时间"></el-input>
        </el-form-item>
        <el-form-item label="供应商名称(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectsuppliername" placeholder="请输入供应商名称"></el-input>
        </el-form-item>
        <el-form-item label="联系电话(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectphone" placeholder="请输入联系电话"></el-input>
        </el-form-item>
        <el-form-item label="实际支付单价(选填)" class="addAdminForm">
          <el-input v-model="editData.Projectshijiprice" placeholder="请输入实际支付单价"></el-input>
        </el-form-item>
        <el-form-item label="是否支付(选填)" class="addAdminForm">
          <el-select v-model="editData.Projectpaystatus" placeholder="请选择" class="select" style="width: 150px;">
            <el-option label="未支付" value="0"></el-option>
            <el-option label="已支付" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="mt20">
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickback">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      editData: {},
      projectlist: []
    }
  },
  mounted () {
  },
  methods: {
    LoadData (parentdata, projectlist) {
      this.editData = parentdata
      this.projectlist = projectlist
    },
    clickback () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditWorkprojectbudget()
    },
    apiEditWorkprojectbudget: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workprojectbudgetid: that.editData.Id,
        projectid: that.editData.Projectid,
        projecttime: that.editData.Projecttime,
        projectproductname: that.editData.Projectproductname,
        projectyujiprice: that.editData.Projectyujiprice,
        projectnum: that.editData.Projectnum,
        projectyujidays: that.editData.Projectyujidays,
        projectshijidays: that.editData.Projectshijidays,
        projectsuppliername: that.editData.Projectsuppliername,
        projectphone: that.editData.Projectphone,
        projectshijiprice: that.editData.Projectshijiprice,
        projectpaystatus: that.editData.Projectpaystatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditWorkprojectbudget, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.select1 {
    width: 109px;
    margin-right: 15px;
}
.speed {
    width: 440px;
    margin-right: 15px;
}
</style>
